import { render, staticRenderFns } from "./ServiceBillingAgreement.vue?vue&type=template&id=2a720485&"
import script from "./ServiceBillingAgreement.vue?vue&type=script&lang=js&"
export * from "./ServiceBillingAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBillingAgreement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports